import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { Head, StoryblokRenderer } from "@cinch-nx/landing-ui-shared";
import { Wrapper } from "@cinch-nx/shared-ui";
import { storyblokComponents } from "./data/storyblok-renderer-map";
import styles from "./our-commitment.module.css";
export function OurCommitmentFeature({ story , generatedAt , preview  }) {
    const typedStory = story;
    const { content  } = useStoryblokState({
        story: typedStory,
        enableBridge: preview
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                generatedAt: generatedAt,
                fallbackTitle: "Our commitment - cinch",
                fallbackDescription: "We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
            }),
            /*#__PURE__*/ _jsxs("article", {
                className: styles.root,
                children: [
                    /*#__PURE__*/ _jsx(Wrapper, {
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                            block: content.introSection,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                            block: content.contentWithIconsSection,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        isFluid: true,
                        backgroundColor: "#ECF5FA",
                        className: {
                            container: styles.statsSectionContainer
                        },
                        children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                            block: content.statsSection,
                            components: storyblokComponents,
                            props: {
                                trackingEventName: "Our commitment - Browse all car clicks"
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                            block: content.helpMeChooseSection,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ _jsx(StoryblokRenderer, {
                        block: content.preFooterCTASection,
                        components: storyblokComponents
                    })
                ]
            })
        ]
    });
}
